module.exports = __webpack_public_path__ + "img/playbnt.c63442db.png";